module.exports = __webpack_public_path__ + "images/other-6e37652687a580ba61c946b459a6f0a4.jpg";